import { cva, type VariantProps } from 'class-variance-authority';

export const cardVariants = cva(
  // TODO: Adjust spacing - gap and padding are set as variables in Figma
  // but need adjusting in tailwind.config (separate ticket)
  'flex flex-col items-start rounded-lg',
  {
    variants: {
      variant: {
        'background-white': 'bg-white',
        'background-gray': 'bg-neutral-50',
        'background-transparent': 'bg-transparent',
      },
      border: {
        none: '',
        padding: 'p-lg',
        stroke: 'p-lg border border-neutral-200',
        shadow: 'p-lg shadow-md',
      },
    },
    defaultVariants: {
      variant: 'background-white',
      border: 'none',
    },
  },
);

export type CardVariantProps = VariantProps<typeof cardVariants>;
